import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BrowserGeocoderPage } from './browser-geocoder.page';

const routes: Routes = [
  {
    path: '',
    component: BrowserGeocoderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrowserGeocoderPageRoutingModule {}
